import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-slate-50">
        <div className="text-xs font-semibold tracking-wider uppercase text-slate-500">
          Loading…
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles && !roles.includes(user.role)) {
    // default redirect based on role
    if (user.role === "corporate") return <Navigate to="/corporate" replace />;
    if (user.assigned_rooftop_id)
      return <Navigate to={`/rooftop/${user.assigned_rooftop_id}`} replace />;
    return <Navigate to="/login" replace />;
  }

  return children;
}
